var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSendIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.88214 4.4649C2.72319 4.62033 2.46533 4.62033 2.3064 4.4649L1.73054 3.90162C1.57159 3.74615 1.57159 3.49409 1.73054 3.33848L4.97537 0.16474C4.98942 0.150889 5.24775 -0.000123039 5.50453 7.52357e-08C5.75855 0.000110882 6.01099 0.151049 6.02503 0.16474L9.26972 3.33848C9.42865 3.49408 9.42865 3.74615 9.26972 3.90162L8.69389 4.4649C8.53496 4.62033 8.27722 4.62033 8.11828 4.4649L6.28591 2.6726V6.54166C6.28591 6.75383 6.10992 6.92603 5.89298 6.92603H5.10729C4.89041 6.92603 4.71451 6.75383 4.71451 6.54166V2.6726L2.88214 4.4649ZM1.57139 10.001H9.42859C10.2965 10.001 11 9.31299 11 8.464V6.54264C11 6.33048 10.8241 6.15845 10.6072 6.15845H9.8215C9.60447 6.15845 9.42859 6.33048 9.42859 6.54264V7.69548C9.42859 8.11997 9.07687 8.464 8.6429 8.464H2.35709C1.92313 8.464 1.57139 8.11997 1.57139 7.69548V6.54264C1.57139 6.33048 1.39553 6.15845 1.17862 6.15845H0.392773C0.176002 6.15845 0 6.33048 0 6.54264V8.46399C0 9.31299 0.703606 10.001 1.57139 10.001Z",
    fill: "#97B7EF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendIcon);
export default __webpack_public_path__ + "static/media/sendIcon.65d56fdf04c801b8a0b774eb97e34fdc.svg";
export { ForwardRef as ReactComponent };